import _                                  from 'underscore';
import React, { FC, useEffect, useState } from 'react';
import { Icon, SemanticICONS }            from 'semantic-ui-react';
import { Cell, Grid }                     from 'styled-css-grid';

import { formatOption }                                     from '@src/util';
import { CorvalMilestone, SemanticUIColor, SemanticUISize } from '@src/types';
import { QueriedSelectFieldProps, SelectField }             from '@src/views/components/forms';
import { queriesHaveData, queriesLoading }                  from '@src/store/_apolloUtil';
import { useSystemData }                                    from '@src/hooks/useSystemData';


interface SystemMilestonesDropdownProps extends QueriedSelectFieldProps {
    loading?: boolean,
    formatOptions?: object,
    allowArchived?: boolean,
    disableArchived?: boolean,
}

const defaultProps: SystemMilestonesDropdownProps = {
    loading:          false,
    formatOptions:    {},
    allowArchived:    false,
    disableArchived:  true,
};

const SystemMilestonesDropdown: FC<SystemMilestonesDropdownProps> = ( _props ) => {

    let { formatOptions, allowArchived, disableArchived, ...props } = _props;

    const [ milestones, setMilestones ]                   = useState<CorvalMilestone[]>( [] ),
          systemData                                      = useSystemData(),
          [ getSystemMilestones, getSystemMilestonesReq ] = systemData.milestoneQuery;

    useEffect( () => {

        getSystemMilestones();

    }, [] );

    let isLoading = ( props.loading || queriesLoading( getSystemMilestonesReq ) );

    useEffect( () => {

        if( queriesHaveData( getSystemMilestonesReq ) ){

            let [ availableMilestones, archivedMilestones ] = _.partition( getSystemMilestonesReq.data.milestones, milestone => ( !milestone.isArchived ) );

            archivedMilestones = allowArchived ? archivedMilestones : []

            setMilestones(
                _.union( availableMilestones, archivedMilestones )
            );
        }

    }, [ getSystemMilestonesReq ] );

    let options = milestones.map( ( milestone: CorvalMilestone ) => {

            const component = (
                <div>
                    <Grid columns={ `auto 1fr` } rows={ `auto` } columnGap={ '10px' }>
                        <Cell middle><Icon size={ SemanticUISize.SMALL } name={ milestone.iconName as SemanticICONS } color={ milestone.colorValue as SemanticUIColor }/></Cell>
                        <Cell middle>{ milestone.name }</Cell>
                    </Grid>
                </div>
            );

            const itemOptions = {
                group:    milestone.isArchived ? 'Archived' : 'Active',
                disabled: disableArchived ? milestone.isArchived : false,
            }

            return {
                ...formatOption( milestone.id, component, { group: itemOptions.group } ),
                disabled: itemOptions.disabled,
            }
        }
    );

    return (
        <SelectField
            { ...props }
            search
            loading={ isLoading }
            options={ options }
        />
    );
};

SystemMilestonesDropdown.defaultProps = defaultProps;

export { SystemMilestonesDropdown };
